import { render, staticRenderFns } from "./ViewEditPreference.vue?vue&type=template&id=4c4044d5&scoped=true"
import script from "./ViewEditPreference.vue?vue&type=script&lang=js"
export * from "./ViewEditPreference.vue?vue&type=script&lang=js"
import style0 from "./ViewEditPreference.vue?vue&type=style&index=0&id=4c4044d5&prod&scoped=true&lang=scss"
import style1 from "./ViewEditPreference.vue?vue&type=style&index=1&id=4c4044d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4044d5",
  null
  
)

export default component.exports